import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    standalone: false
})
export class ErrorMessageComponent {
  @Input() message: string = '';
  @Input() isError: boolean = false;

  constructor() {}
}
